import { Chart } from 'chart.js';

export const valueLabelsColumn = {
  id: 'valueLabelsColumn',
  afterDatasetsDraw(chart: Chart) {
    const { ctx, data } = chart;

    const currentQuarter = Math.ceil((new Date().getMonth() + 1) / 3);

    ctx.save();
    ctx.font = 'bold 14px "Arial"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    const percentageDataset = data.datasets.find(dataset => dataset.label === 'Направление в %' || dataset.label === '% GOP/Направление/Блок');
    const percentageDatasetIndex = data.datasets.findIndex(dataset => dataset.label === 'Направление в %' || dataset.label === '% GOP/Направление/Блок');

    if (percentageDataset && percentageDatasetIndex !== -1) {

      percentageDataset.data.forEach((value, index) => {
        const meta = chart.getDatasetMeta(percentageDatasetIndex);
        const element = meta.data[index];

        if (element && typeof value === 'number') {
          const x = element.x;
          const y = element.y;

          ctx.fillStyle = index < currentQuarter ? '#374151' : 'rgba(55, 65, 81, 0.5)';

          ctx.fillText(value + ' %', x, y - 8);
        }
      });
    }

    ctx.restore();
  },
};

export const valueLabelsColumnInside = {
  id: 'valueLabelsColumnInside',
  afterDatasetsDraw(chart: Chart) {
    const { ctx, data } = chart;

    const currentMonth = new Date().getMonth() + 1;

    ctx.save();
    ctx.font = 'bold 18px "Arial"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const percentageDataset = data.datasets.find(dataset => dataset.label === '% GOP/Направление/Блок');
    const percentageDatasetIndex = data.datasets.findIndex(dataset => dataset.label === '% GOP/Направление/Блок');

    if (percentageDataset && percentageDatasetIndex !== -1) {
      const meta = chart.getDatasetMeta(percentageDatasetIndex);

      percentageDataset.data.forEach((value: any, index) => {
        const element = meta.data[index] as any;

        if (element && value !== null && typeof value === 'number' && value > 0) {
          const x = element.x;
          const base = element.base || 0;
          const top = element.y || 0;
          const y = (base + top) / 2;

          ctx.fillStyle = index < currentMonth ? '#374151' : 'rgba(55, 65, 81, 0.5)';

          ctx.fillText(value + '%', x, y);
        } else if (element && value !== null && typeof value === 'object' && value.value !== undefined && value.value > 0) {
          const x = element.x;
          const base = element.base || 0;
          const top = element.y || 0;
          const y = (base + top) / 2;

          ctx.fillStyle = index < currentMonth ? '#374151' : 'rgba(55, 65, 81, 0.5)';

          ctx.fillText(value.value + '%', x, y);
        }
      });
    }

    ctx.restore();
  },
};

export const yearLabelsPlugin = {
  id: 'yearLabels',
  afterDraw(chart: Chart) {
    const boundaries: Array<{ year: number; startIndex: number }> | undefined =
      (chart.options as any).plugins?.yearLabels?.boundaries;

    if (!boundaries || boundaries.length <= 1) return;

    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    if (!meta || meta.data.length === 0) return;

    const xAxis = chart.scales.x;

    ctx.save();
    ctx.font = 'bold 13px Arial';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#374151';

    boundaries.forEach((boundary, i) => {
      const nextStartIndex = boundaries[i + 1]?.startIndex ?? meta.data.length;
      const startIdx = boundary.startIndex;
      const endIdx = Math.min(nextStartIndex - 1, meta.data.length - 1);

      if (startIdx >= meta.data.length) return;

      const startX = (meta.data[startIdx] as any).x;
      const endX = (meta.data[endIdx] as any).x;
      const centerX = (startX + endX) / 2;
      const y = xAxis.bottom + 20;

      ctx.fillText(String(boundary.year), centerX, y);
    });

    ctx.restore();
  },
};

export const valueLabelsLine = {
  id: 'valueLabelsLine',
  afterDatasetsDraw(chart: Chart) {
    const { ctx, data } = chart;

    ctx.save();
    ctx.font = 'normal 18px "Arial"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    data.datasets.forEach((dataset, datasetIndex) => {
      if (dataset.type === 'line' && (dataset.label === 'KPI план' || dataset.label === 'KPI факт')) {
        const meta = chart.getDatasetMeta(datasetIndex);

        dataset.data.forEach((value, index) => {
          const element = meta.data[index];

          if (element && typeof value === 'number') {
            const x = element.x;
            const y = element.y;

            ctx.fillStyle = dataset.borderColor as string || '#000';

            ctx.fillText(String(value), x, y - 3);
          }
        });
      }
    });

    ctx.restore();
  },
};